export default {
  app: {
    golf: {
      title: '球場資訊',
      hasEVChargingPoint: '電動車充電站',
      hasCaddieService: '球僮服務',
      hasTrolley: '手推車',
      hasBuggy: '球車',
      hasClubRental: '球桿租借',
      hasAcademy: '學院',
      hasMarshal: '球場管理員',
      hasPGACertification: 'PGA 認證',
      hasTrainingArea: '訓練區',
      hasRestaurant: '餐廳',
      hasHotel: '酒店',
      hasDogsOnCourse: '可攜帶狗進入球場',
      numberOfHoles: '球洞數量',
    },
  },
};
